import { useEffect } from "react";
import useViewport from "../../../Utilities/useViewport";
import APLTabs from "./APLTabs";
import useTeacherNavStore from "../../../stores/useTeacherNavStore";
import { GetUnviewedWorkRegistrationCountsByPeriod } from "../../../actions/teacherQueries";
import { MarkWorkRegistrationsAsViewed } from "../../../actions/teacherMutations";
import { useQueryClient } from "@tanstack/react-query";

export default function APLTabNavSelector({
  activeTab,
  toggleCreatePeriod,
  toggleExportModal,
  toggleEditSupervisors,
  periodsToSelect,
  period,
}) {
  const { width } = useViewport();
  const breakpoint = 620;
  const isMobile = width < breakpoint;

  const setSelectedAplPeriodId = useTeacherNavStore((state) => state.setSelectedAplPeriodId);
  const setSelectedAplTab = useTeacherNavStore((state) => state.setSelectedAplTab);
  const queryClient = useQueryClient();

  const periodId = period?.period?.id;
  const { data: unviewedCountsByPeriod } =
    GetUnviewedWorkRegistrationCountsByPeriod();
  const unviewedCount =
    unviewedCountsByPeriod && periodId
      ? unviewedCountsByPeriod[periodId] || 0
      : 0;

  useEffect(() => {
    if (activeTab === 3 && periodId && unviewedCount > 0) {
      queryClient.invalidateQueries({ queryKey: ["FetchEvents"] });
      MarkWorkRegistrationsAsViewed(periodId).then((result) => {
        if (result?.status === 200) {
          queryClient.invalidateQueries({ queryKey: [
            "FetchUnviewedWorkRegistrationCountsByPeriod",
          ] });
        } else {
          console.warn("MarkWorkRegistrationsAsViewed failed", result);
        }
      });
    }
  }, [activeTab, periodId, unviewedCount, queryClient]);

  const handleSelectPeriod = (event) => {
    setSelectedAplPeriodId(event.value);
  };

  let selectedPeriod = null;
  if (period !== null) {
    selectedPeriod = periodsToSelect.find(
      (pts) => pts.value === period.period.id,
    );
  }
  const handleSetAplTab = async (tabNr) => {
    setSelectedAplTab(tabNr);
  };

  return (
    <APLTabs
      toggleCreatePeriod={toggleCreatePeriod}
      toggleExportModal={toggleExportModal}
      toggleEditSupervisors={toggleEditSupervisors}
      periodsToSelect={periodsToSelect}
      period={period}
      activeTab={activeTab}
      handleSelectPeriod={handleSelectPeriod}
      selectedPeriod={selectedPeriod}
      handleSetAplTab={handleSetAplTab}
      isMobile={isMobile}
      unviewedCount={unviewedCount || 0}
      unviewedCountsByPeriod={unviewedCountsByPeriod || {}}
    />
  );
}
